export const useVodPaywayToken = pbiData => {
  const isPlayFreemiumButtom = pbiData?.playFreemiumButton?.visible === '1';

  const playButton = isPlayFreemiumButtom
    ? pbiData?.playFreemiumButton
    : pbiData?.playButton;

  const paywayToken = playButton?.payway_token;

  const getPlayButton = pbiInfo =>
    pbiInfo?.playFreemiumButton?.visible === '1'
      ? pbiInfo?.playFreemiumButton
      : pbiInfo?.playButton;

  return {
    paywayToken,
    playButton,
    isPlayFreemiumButtom,
    getPlayButton,
  };
};
